module.exports = __webpack_public_path__ + "static/media/room-10.b9bcc1e3.jpg";